import script from "./Place.vue?vue&type=script&setup=true&lang=js"
export * from "./Place.vue?vue&type=script&setup=true&lang=js"

import "./Place.vue?vue&type=style&index=0&id=0bdfe9b9&lang=less&scoped=true"

import exportComponent from "D:\\aj项目\\code\\清洁能源\\氢能会议系统\\chic-conference\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bdfe9b9"]])

export default __exports__